// Toggle this flag to fetch configs from \public\plantsJSON folder
export const fetchFromLocalPlantsJSON = false;

export const maxZoomLgvIconSize = [9, 9];
export const maxZoomLgvIconTuneValue = [38, -30];

export const DB_ERROR = "Error connecting to datasource!";
export const BLOCK_RACK_POLLING_INTERVAL = 2 * 60 * 1000; // 2 minutes
export const API_MAX_RETRIES = 2;
export const API_RETRY_DELAY = 1000; // 1 second

export const userDataObject = {
  businessPhones: [],
  displayName: "",
  givenName: "",
  jobTitle: null,
  mail: "",
  mobilePhone: null,
  officeLocation: "",
  preferredLanguage: null,
  surname: "",
  userPrincipalName: "",
  id: ""
};

export const heatmapHorizontalCount = 25;
export const heatmapVerticalCount = 57;

export const plantCarLatSize = 27;
export const plantCarLngSize = 27;

export const heatMapGridX = -1750.3403361344538;
export const heatMapGridY = 538.1567444620252;

export const navHeatmapMaxRetry = 10;

export const rackColorSortOrder = [
  "red",
  "pink",
  "grey",
  "green",
  "blue",
  "yellow"
];

export const COLOR_CODES = {
  antarctica: "#b9b9b9",
  azureBlue: "#1E90FF",
  butterflyBlue: "#13aceb",
  black: "#000000",
  blue: "#0000ff",
  blueCharm: "#83c4d9",
  brickRed: "#bf2e3a",
  brightRed: "#ff0000",
  bubbleGum: "#ffc0cb",
  cherryRed: "#dc143c",
  chromeYellow: "#fbaa05",
  coralBlue: "#B0E0E6",
  darkOrange: "#FF8C00",
  deepFuschia: "#ba55d3",
  deepGreen: "#06700d",
  denimBlue: "#8cb4f0",
  dirtyBlue: "#4682B4",
  forestGreen: "#238749",
  golden: "#eec909",
  goldOrange: "#d96e0b",
  grassGreen: "#38ab00",
  harlequinGreen: "#42c721",
  hulkGreen: "#008000",
  lightIndigo: "#6A5ACD",
  lightOrchid: "#dda0dd",
  maroon: "#800000",
  mediumOrchid: "#ba55d3",
  mintGreen: "#01cc1f",
  orangePeel: "#ffa500",
  paleCanary: "#ffff96",
  paleSilver: "#c3c3c3",
  papayaOrange: "#e77400",
  pinkPride: "#ef1fda",
  powderBlue: "#b0e0e6",
  richBlue: "#0000FF",
  richGreen: "#238749",
  royalBlue: "#4169e1",
  purpleBlue: "#4133e1",
  seafoamGreen: "#96ffc8",
  silver: "#c0c0c0",
  skyBlue: "#87ceeb",
  slateBlue: "#6a5acd",
  sparklingRed: "#ee3232",
  teal: "#008080",
  tomatoRed: "#ff6347",
  treeGreen: "#008000",
  vampireGray: "#555555",
  veryLightBrown: "#deb887",
  vibrantGreen: "#17e711",
  white: "#ffffff"
};

export const dashboardLegends = [
  {
    title: "LGV",
    statusColors: [
      { label: "Available", value: COLOR_CODES.hulkGreen },
      { label: "Charging", value: COLOR_CODES.blueCharm },
      { label: "Deadlock", value: COLOR_CODES.pinkPride },
      { label: "In Alarm", value: COLOR_CODES.sparklingRed },
      { label: "In Manual", value: COLOR_CODES.maroon },
      { label: "In Operation/Traffic", value: COLOR_CODES.goldOrange },
      { label: "Loaded", value: COLOR_CODES.blue },
      { label: "Lost", value: COLOR_CODES.antarctica },
      { label: "Removed", value: COLOR_CODES.black }
    ]
  },
  {
    title: "Production Line",
    statusColors: [
      { label: "Line Running", value: COLOR_CODES.purpleBlue },
      {
        label: "Pallets waiting for pickup",
        value: COLOR_CODES.harlequinGreen
      },
      { label: "# LGVs to pickup at line", value: COLOR_CODES.richGreen }
    ]
  },
  {
    title: "Trailer Pallet",
    statusColors: [
      { label: "Aborted", value: COLOR_CODES.tomatoRed },
      { label: "Allocated", value: COLOR_CODES.mediumOrchid },
      { label: "Canceled", value: COLOR_CODES.cherryRed },
      { label: "Can Allocate", value: COLOR_CODES.slateBlue },
      { label: "Completed", value: COLOR_CODES.deepGreen },
      { label: "Enqueued To Start", value: COLOR_CODES.slateBlue },
      { label: "In Transit/Started", value: COLOR_CODES.royalBlue },
      { label: "New", value: COLOR_CODES.silver },
      { label: "Parked", value: COLOR_CODES.teal },
      { label: "Releasable", value: COLOR_CODES.butterflyBlue },
      { label: "Released", value: COLOR_CODES.skyBlue },
      { label: "Wait Start Confirm", value: COLOR_CODES.powderBlue }
    ]
  },
  {
    title: "Dock Door",
    statusColors: [
      { label: "OK to Enter", value: COLOR_CODES.white },
      { label: "Manual", value: COLOR_CODES.chromeYellow },
      { label: "Auto", value: COLOR_CODES.vibrantGreen }
    ]
  }
];

export const yardLegends = [
  {
    title: "Yard Slot Status",
    statusColors: [
      { label: "CHECKED IN", value: COLOR_CODES.denimBlue },
      { label: "COMPLETED", value: COLOR_CODES.seafoamGreen },
      { label: "LOADING", value: COLOR_CODES.paleCanary },
      { label: "OPEN", value: COLOR_CODES.paleSilver },
      { label: "PENDING", value: COLOR_CODES.paleSilver },
      { label: "PROGRESS", value: COLOR_CODES.orangePeel },
      { label: "UNAVAILABLE", value: COLOR_CODES.paleSilver }
    ]
  },
  {
    title: "Trailer Status",
    statusColors: [
      {
        label: "Inbound / Preload over 1 Hour",
        value: COLOR_CODES.lightOrchid
      },
      {
        label: "Inbound / Preload over 2 Hours",
        value: COLOR_CODES.deepFuschia
      },
      { label: "Live Load over 1 Hour", value: COLOR_CODES.bubbleGum },
      { label: "Live Load over 2 Hours", value: COLOR_CODES.brightRed },
      {
        label: "Unavailable Dock Door or Yard Slot",
        value: COLOR_CODES.veryLightBrown
      }
    ]
  }
];

export const allocatedViewLegends = [
  {
    label: "Pending",
    colorName: "Orange",
    background: COLOR_CODES.papayaOrange
  },
  {
    label: "Allocated",
    colorName: "Yellow",
    background: COLOR_CODES.golden
  },
  {
    label: "Executing",
    colorName: "Green",
    background: COLOR_CODES.grassGreen
  },
  {
    label: "Paused",
    colorName: "Light Green",
    background: COLOR_CODES.mintGreen
  },
  {
    label: "Complete",
    colorName: "Dark Green",
    background: COLOR_CODES.forestGreen
  },
  {
    label: "Stalled",
    colorName: "Red",
    background: COLOR_CODES.brickRed
  }
];

export const statusColorMap = {
  // Shipment statuses
  "Wait Qty Check": COLOR_CODES.vampireGray,
  Scheduled: COLOR_CODES.azureBlue,
  "Wait Dock Cnfrm": COLOR_CODES.dirtyBlue,
  "Wait Start Cnfrm": COLOR_CODES.coralBlue,
  "Enqueued To Start": COLOR_CODES.lightIndigo,
  Started: COLOR_CODES.royalBlue,
  Staged: COLOR_CODES.deepGreen,
  Suspended: COLOR_CODES.darkOrange,
  // LGV statuses
  Traffic: COLOR_CODES.goldOrange,
  Alarm: COLOR_CODES.sparklingRed,
  Removed: COLOR_CODES.black,
  Charging: COLOR_CODES.blueCharm,
  Idle: COLOR_CODES.treeGreen,
  "LGV In Manual": COLOR_CODES.maroon,
  ActiveFull: COLOR_CODES.richBlue,
  ActiveEmpty: COLOR_CODES.treeGreen,
  // Dock Door statuses
  Aborted: COLOR_CODES.tomatoRed,
  Allocated: COLOR_CODES.mediumOrchid,
  CanAllocate: COLOR_CODES.slateBlue,
  Canceled: COLOR_CODES.cherryRed,
  Completed: COLOR_CODES.deepGreen,
  EnqueuedToStart: COLOR_CODES.slateBlue,
  InTransit: COLOR_CODES.royalBlue,
  New: COLOR_CODES.silver,
  Parked: COLOR_CODES.teal,
  Releasable: COLOR_CODES.azureBlue,
  Released: COLOR_CODES.skyBlue,
  // Started: COLOR_CODES.royalBlue  // since the color is same for shipment status Started
  WaitStartCnfrm: COLOR_CODES.powderBlue
};

export const getPlantCoordinates = (plant, renderObject) => {
  if (plant === "CAR") {
    // current
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 4500,
        rectTopRightX: 553500,
        rectTopRightY: 188000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 453500,
        rectTopRightY: 168000
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 455000,
        rectTopRightY: 168000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 450000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "ATL") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 78000,
        rectBottomLeftY: 12000,
        rectTopRightX: 533000,
        rectTopRightY: 195000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 85000, //R->L
        rectBottomLeftY: 32000, //T->B
        rectTopRightX: 472000, //R->L shrink
        rectTopRightY: 153500 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -1300,
        rectBottomLeftY: 2000,
        rectTopRightX: 384000,
        rectTopRightY: 125300
      };
    } else {
      return {
        //map
        rectBottomLeftX: 47000, //15000
        rectBottomLeftY: 13000, //333000
        rectTopRightX: 523000, //0
        rectTopRightY: 171000 //143000
      };
    }
  } else if (plant === "DET") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 80000,
        rectBottomLeftY: 12000,
        rectTopRightX: 473000,
        rectTopRightY: 195000
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 14000, // decreasing L->R
        rectBottomLeftY: -4500, // shrink B->T 1000
        rectTopRightX: 334700,
        rectTopRightY: 145500 // increase T->B 146000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 127000, //R->L
        rectBottomLeftY: 36000, //T->B
        rectTopRightX: 449000, //R->L shrink
        rectTopRightY: 170000 // T->B shrink
      };
    } else {
      return {
        //map
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "ALA") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: -20000, //T->B
        rectTopRightX: 415000, //R->L shrink
        rectTopRightY: 172000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: 38000, //T->B
        rectTopRightX: 410000, //R->L shrink
        rectTopRightY: 188500 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 42500,
        rectBottomLeftY: 108000,
        rectTopRightX: 339000,
        rectTopRightY: 267000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 20000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "HAZ") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 237000, //R->L
        rectBottomLeftY: 200000, //T->B
        rectTopRightX: 902000, //R->L shrink
        rectTopRightY: 450000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 207000, //R->L
        rectBottomLeftY: 270000, //T->B
        rectTopRightX: 642000, //R->L shrink
        rectTopRightY: 470000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 116000,
        rectBottomLeftY: 212500,
        rectTopRightX: 555000,
        rectTopRightY: 410000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
    // return {
    //   rectBottomLeftX: 116000,
    //   rectBottomLeftY: 214000,
    //   rectTopRightX: 555000,
    //   rectTopRightY: 410000,
    // };
  } else if (plant === "HOU") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 108000, //R->L
        rectBottomLeftY: -9000, //T->B
        rectTopRightX: 522000, //R->L shrink
        rectTopRightY: 131000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -2500,
        rectBottomLeftY: 0,
        rectTopRightX: 376900,
        rectTopRightY: 118000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 116500, //R->L
        rectBottomLeftY: 33000, //T->B
        rectTopRightX: 495000, //R->L shrink
        rectTopRightY: 151000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "LAS") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 84000, //R->L
        rectBottomLeftY: -16000, //T->B
        rectTopRightX: 392000, //R->L shrink
        rectTopRightY: 152000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 19000,
        rectBottomLeftY: -53000,
        rectTopRightX: 317000,
        rectTopRightY: 210000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 81000, //R->L
        rectBottomLeftY: 33000, //T->B
        rectTopRightX: 370000, //R->L shrink
        rectTopRightY: 169000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "MIA") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 85000, //R->L
        rectBottomLeftY: -5000, //T->B
        rectTopRightX: 380000, //R->L shrink
        rectTopRightY: 165000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 81000, //R->L
        rectBottomLeftY: 33000, //T->B
        rectTopRightX: 355000, //R->L shrink
        rectTopRightY: 190000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -25000,
        rectBottomLeftY: 136000,
        rectTopRightX: 250000,
        rectTopRightY: -25000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "TAC") {
    // current
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 90000, //R->L
        rectBottomLeftY: -30000, //T->B
        rectTopRightX: 315000, //R->L shrink
        rectTopRightY: 140000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 45000, //R->L
        rectBottomLeftY: 17500, //T->B
        rectTopRightX: 401000, //R->L shrink
        rectTopRightY: 167000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -40000,
        rectBottomLeftY: 55000,
        rectTopRightX: 310000,
        rectTopRightY: 208000
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "JAX") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 80000, //R->L
        rectBottomLeftY: -50000, //T->B
        rectTopRightX: 565000, //R->L shrink
        rectTopRightY: 170000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 70000, //R->L
        rectBottomLeftY: 20500, //T->B
        rectTopRightX: 465000, //R->L shrink
        rectTopRightY: 200000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 11000,
        rectBottomLeftY: 8500,
        rectTopRightX: 409000,
        rectTopRightY: 185000
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "LAN") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: -18000, //R->L
        rectBottomLeftY: -75000, //T->B
        rectTopRightX: 568000, //R->L shrink
        rectTopRightY: 150000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: -1500, //R->L
        rectBottomLeftY: 20500, //T->B
        rectTopRightX: 525000, //R->L shrink
        rectTopRightY: 245000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "ST3") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 70000, //R->L
        rectBottomLeftY: -100000, //T->B
        rectTopRightX: 510500, //R->L shrink
        rectTopRightY: 140000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 80000, //R->L
        rectBottomLeftY: 20500, //T->B
        rectTopRightX: 462500, //R->L shrink
        rectTopRightY: 165000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 1000,
        rectBottomLeftY: 5000,
        rectTopRightX: 383000,
        rectTopRightY: 150000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "BAL") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 70000, //R->L
        rectBottomLeftY: -145000, //T->B
        rectTopRightX: 470000, //R->L shrink BAL
        rectTopRightY: 100000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 93000, //R->L
        rectBottomLeftY: 1500, //T->B
        rectTopRightX: 463500, //R->L shrink BAL
        rectTopRightY: 169000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "KC2") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 91000, //R->L
        rectBottomLeftY: -58000, //T->B
        rectTopRightX: 470500, //R->L shrink KC2
        rectTopRightY: 140000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 91500, //R->L
        rectBottomLeftY: 1500, //T->B
        rectTopRightX: 459900, //R->L shrink BAL
        rectTopRightY: 169000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "MOR") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 63000, //R->L
        rectBottomLeftY: -90000, //T->B
        rectTopRightX: 510000, //R->L shrink BAL
        rectTopRightY: 134000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 78500, //R->L
        rectBottomLeftY: 1800, //T->B
        rectTopRightX: 499500, //R->L shrink BAL
        rectTopRightY: 168500 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 0, //R->L
        rectBottomLeftY: 0, //T->B
        rectTopRightX: 0, //R->L shrink
        rectTopRightY: 0 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 529700,
        rectTopRightY: 161000
      };
    }
  } else if (plant === "TEM") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 85000, //R->L
        rectBottomLeftY: -90000, //T->B
        rectTopRightX: 520000, //R->L shrink BAL
        rectTopRightY: 120000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: -46800, //R->L
        rectBottomLeftY: -55500, //T->B
        rectTopRightX: 350500, //R->L shrink TEM
        rectTopRightY: 121000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 0, //R->L
        rectBottomLeftY: 0, //T->B
        rectTopRightX: 0, //R->L shrink
        rectTopRightY: 0 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 161000
      };
    }
  } else if (plant === "LOU") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 82000,
        rectBottomLeftY: 15500,
        rectTopRightX: 463000,
        rectTopRightY: 148000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 92000, //R->L
        rectBottomLeftY: 13000, //T->B
        rectTopRightX: 445000, //R->L shrink LOU
        rectTopRightY: 148500 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "BAY") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 100000,
        rectBottomLeftY: -15500,
        rectTopRightX: 433000,
        rectTopRightY: 170000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 93000, //R->L
        rectBottomLeftY: 500, //T->B
        rectTopRightX: 425000, //R->L shrink BAY
        rectTopRightY: 175000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -96000,
        rectBottomLeftY: -55800,
        rectTopRightX: 240000,
        rectTopRightY: 125000
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "KNC") {
    //KNC PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 110000,
        rectBottomLeftY: 5000,
        rectTopRightX: 403000,
        rectTopRightY: 218000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 14000, //R->L
        rectBottomLeftY: 55500, //T->B
        rectTopRightX: 300000, //R->L shrink
        rectTopRightY: 212000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 16000,
        rectTopRightX: 583000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "COL") {
    // current
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 82000,
        rectBottomLeftY: -40500,
        rectTopRightX: 343000,
        rectTopRightY: 120000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 303800, //R->L
        rectBottomLeftY: 13000, //T->B
        rectTopRightX: 675000, //R->L shrink RCH
        rectTopRightY: 150000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 34000,
        rectTopRightX: 425000,
        rectTopRightY: 176000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "RCH") {
    if (renderObject === "heatmap") {
      return {
        //RCH plant
        rectBottomLeftX: 91600,
        rectBottomLeftY: -7500,
        rectTopRightX: 508000,
        rectTopRightY: 148000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 61000, //R->L
        rectBottomLeftY: 24000, //T->B
        rectTopRightX: 462000, //R->L shrink RCH
        rectTopRightY: 159000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 0,
        rectBottomLeftY: -6000,
        rectTopRightX: 435000,
        rectTopRightY: 131000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "BLM") {
    //BLM PLANT CURRENT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 130000,
        rectBottomLeftY: 500,
        rectTopRightX: 430000,
        rectTopRightY: 168000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 14000, //R->L
        rectBottomLeftY: 56500, //T->B
        rectTopRightX: 317000, //R->L shrink BLM
        rectTopRightY: 190000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 16000,
        rectTopRightX: 583000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "KEN") {
    //KEN PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 74000,
        rectBottomLeftY: -2500,
        rectTopRightX: 415000,
        rectTopRightY: 138000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 1000, //R->L
        rectBottomLeftY: 67000, //T->B
        rectTopRightX: 342000, //R->L shrink KEN
        rectTopRightY: 170000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 16000,
        rectTopRightX: 583000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "SAN") {
    //SAN PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 57000,
        rectBottomLeftY: 35500,
        rectTopRightX: 505000,
        rectTopRightY: 188000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 11000, //R->L
        rectBottomLeftY: 36500, //T->B
        rectTopRightX: 460000, //R->L shrink BLM
        rectTopRightY: 158000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 14000,
        rectTopRightX: 583000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "SL2") {
    //SL2 PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 110000,
        rectBottomLeftY: 30500,
        rectTopRightX: 300000,
        rectTopRightY: 188000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: -6500, //R->L
        rectBottomLeftY: 60000, //T->B
        rectTopRightX: 189500, //R->L shrink SL2
        rectTopRightY: 192000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 16000,
        rectTopRightX: 583000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "MES") {
    //MES PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 110000,
        rectBottomLeftY: 30500,
        rectTopRightX: 490000,
        rectTopRightY: 215000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 14000, //R->L
        rectBottomLeftY: 58500, //T->B
        rectTopRightX: 387000, //R->L shrink BLM
        rectTopRightY: 197000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 29000,
        rectBottomLeftY: 30000,
        rectTopRightX: 405000,
        rectTopRightY: 173000
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 15000,
        rectTopRightX: 583000,
        rectTopRightY: 191000
      };
    }
  } else if (plant === "MIS") {
    //MIS PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 120000,
        rectBottomLeftY: 13500,
        rectTopRightX: 450000,
        rectTopRightY: 228000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 27000, //R->L
        rectBottomLeftY: 50000, //T->B
        rectTopRightX: 410000, //R->L shrink MIS
        rectTopRightY: 220000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -8500,
        rectBottomLeftY: 16500,
        rectTopRightX: 380000,
        rectTopRightY: 197200
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 15000,
        rectTopRightX: 583000,
        rectTopRightY: 191000
      };
    }
  } else if (plant === "PIT") {
    //PIT PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 65000,
        rectBottomLeftY: 0,
        rectTopRightX: 409000,
        rectTopRightY: 225000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: -12000, //R->L
        rectBottomLeftY: 56000, //T->B
        rectTopRightX: 328000, //R->L shrink PIT
        rectTopRightY: 220000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 10000,
        rectTopRightX: 590000,
        rectTopRightY: 231000
      };
    }
  } else if (plant === "MTY") {
    //MTY PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 117000,
        rectBottomLeftY: 15500,
        rectTopRightX: 462000,
        rectTopRightY: 215000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 220000, //R->L
        rectBottomLeftY: 46000, //T->B
        rectTopRightX: 561500, //R->L shrink PIT
        rectTopRightY: 172000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 15000,
        rectTopRightX: 583000,
        rectTopRightY: 191000
      };
    }
  } else if (plant === "OKC") {
    //OKC PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 115000,
        rectBottomLeftY: 14500,
        rectTopRightX: 450000,
        rectTopRightY: 208000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 19000, //R->L
        rectBottomLeftY: 67700, //T->B
        rectTopRightX: 362500, //R->L shrink OKC
        rectTopRightY: 239500 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 15000,
        rectTopRightX: 583000,
        rectTopRightY: 191000
      };
    }
  } else if (plant === "MXC") {
    //MIS PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 110000,
        rectBottomLeftY: -20500,
        rectTopRightX: 440000,
        rectTopRightY: 268000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 28000, //R->L
        rectBottomLeftY: 66000, //T->B
        rectTopRightX: 351000, //R->L shrink MXC
        rectTopRightY: 262000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: -42000,
        rectTopRightX: 583000,
        rectTopRightY: 191000
      };
    }
  } else if (plant === "NOR") {
    //NOR PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 4500,
        rectTopRightX: 553500,
        rectTopRightY: 188000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 453500,
        rectTopRightY: 168000
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 455000,
        rectTopRightY: 168000
      };
    } else {
      return {
        rectBottomLeftX: 150000,
        rectBottomLeftY: 50000,
        rectTopRightX: 550000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "BAK") {
    // current
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 4500,
        rectTopRightX: 553500,
        rectTopRightY: 188000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 453500,
        rectTopRightY: 168000
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 455000,
        rectTopRightY: 168000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 13000,
        rectTopRightX: 450000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "RIA") {
    //RIA PLANT
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 4500,
        rectTopRightX: 553500,
        rectTopRightY: 188000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 453500,
        rectTopRightY: 168000
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 14500,
        rectTopRightX: 455000,
        rectTopRightY: 168000
      };
    } else {
      return {
        rectBottomLeftX: 130000,
        rectBottomLeftY: -60000,
        rectTopRightX: 450000,
        rectTopRightY: 150000
      };
    }
  } else if (plant === "ST4") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: -20000, //T->B
        rectTopRightX: 415000, //R->L shrink
        rectTopRightY: 172000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: 38000, //T->B
        rectTopRightX: 410000, //R->L shrink
        rectTopRightY: 188500 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 42500,
        rectBottomLeftY: 108000,
        rectTopRightX: 339000,
        rectTopRightY: 267000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 20000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "PLA") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: -20000, //T->B
        rectTopRightX: 415000, //R->L shrink
        rectTopRightY: 172000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: 38000, //T->B
        rectTopRightX: 410000, //R->L shrink
        rectTopRightY: 188500 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 42500,
        rectBottomLeftY: 108000,
        rectTopRightX: 339000,
        rectTopRightY: 267000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 20000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "GDL") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: -20000, //T->B
        rectTopRightX: 415000, //R->L shrink
        rectTopRightY: 172000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: 38000, //T->B
        rectTopRightX: 410000, //R->L shrink
        rectTopRightY: 188500 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 42500,
        rectBottomLeftY: 108000,
        rectTopRightX: 339000,
        rectTopRightY: 267000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 20000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "MIN") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: -20000, //T->B
        rectTopRightX: 415000, //R->L shrink
        rectTopRightY: 172000 // T->B shrink
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 105000, //R->L
        rectBottomLeftY: 38000, //T->B
        rectTopRightX: 410000, //R->L shrink
        rectTopRightY: 188500 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: 42500,
        rectBottomLeftY: 108000,
        rectTopRightX: 339000,
        rectTopRightY: 267000
      };
    } else {
      return {
        rectBottomLeftX: 47000,
        rectBottomLeftY: 20000,
        rectTopRightX: 523000,
        rectTopRightY: 171000
      };
    }
  } else if (plant === "CIN") {
    if (renderObject === "heatmap") {
      return {
        rectBottomLeftX: 120000,
        rectBottomLeftY: 13500,
        rectTopRightX: 450000,
        rectTopRightY: 228000
      };
    } else if (renderObject === "lgv") {
      return {
        rectBottomLeftX: 27000, //R->L
        rectBottomLeftY: 50000, //T->B
        rectTopRightX: 410000, //R->L shrink MIS
        rectTopRightY: 220000 // T->B shrink
      };
    } else if (renderObject === "destinations") {
      return {
        rectBottomLeftX: 88000, //R->L
        rectBottomLeftY: -42500, //T->B
        rectTopRightX: -292000, //R->L shrink
        rectTopRightY: -450000 // T->B shrink
      };
    } else if (renderObject === "block" || renderObject === "rack") {
      return {
        rectBottomLeftX: -8500,
        rectBottomLeftY: 16500,
        rectTopRightX: 380000,
        rectTopRightY: 197200
      };
    } else {
      return {
        rectBottomLeftX: 50000,
        rectBottomLeftY: 15000,
        rectTopRightX: 583000,
        rectTopRightY: 191000
      };
    }
  }
};

export const indoorMapZoomScale = [
  "scale(1)",
  "scale(1.5)",
  "scale(2)",
  "scale(2.5)",
  "scale(3)",
  "scale(3.5)",
  "scale(4)",
  "scale(4.5)",
  "scale(5)"
];

export const SOCKET_CHANNELS = {
  ALLOCATED_VIEW: "DOCK_DOOR_ALLOCATED_VIEW",
  BATTERY_STATIONS: "BATTERY_STATION_DETAILS",
  BILLBOARD_MESSAGES: "BILL_BOARD_MESSAGES",
  BLOCK_STORAGES: "BLOCK_STORAGE_DETAILS",
  CONFIG: "CONFIG_DETAILS",
  DOCK_DOORS: "DOCK_DOOR_DETAILS",
  LGV_COORDINATES: "LGV_COORDINATES",
  LGV_DETAILS: "LGV_DETAILS",
  LGV_FLEET_COUNT: "LGV_FLEET_COUNT",
  LGV_FLEET_STATUS: "LGV_FLEET_STATUS",
  LGV_POSITION: "LGV_POSITION",
  LGV_LIST: "LGV_LIST",
  NON_LGV: "NON_LGV_DETAILS",
  PLANT_CONFIG: "PLANT_CONFIG",
  PRODUCTION_LINES: "PRODUCTION_DETAILS",
  RACK_STORAGE: "RACK_STORAGE_DETAILS",
  SHIFT: "SHIFT_DETAILS",
  SHIPMENT: "SHIPMENT_DETAILS",
  SHIPMENT_STATUS: "SHIPMENT_STATUS",
  TRAILER_ARRIVAL: "TRAILER_ARRIVAL_NOTIFICATION",
  WAREHOUSE_CAPACITY: "WAREHOUSE_CAPACITY",
  YARD_CAPACITY: "YARD_CAPACITY_DETAILS",
  YARD_OBJECTS: "YARD_OBJECT_DETAILS"
};

export const transformMap = {
  "1.0": { scale: 1.0, translate: [0, 0] },
  1.2: { scale: 1.2, translate: [120, 50] },
  1.4: { scale: 1.4, translate: [210, 90] },
  1.6: { scale: 1.6, translate: [275, 120] },
  1.8: { scale: 1.8, translate: [325, 135] },
  "2.0": { scale: 2.0, translate: [360, 155] },
  2.2: { scale: 2.2, translate: [380, 175] },
  2.4: { scale: 2.4, translate: [400, 195] },
  2.6: { scale: 2.6, translate: [420, 215] },
  2.8: { scale: 2.8, translate: [440, 235] },
  "3.0": { scale: 3.0, translate: [460, 255] }
};

export const zoomTransformArr = [
  "scale(1)", // zoom level 1
  "scale(1.2) translate(0)",
  "scale(1.4) translate(0)",
  "scale(1.6) translate(0)",
  "scale(1.8) translate(0)",
  "scale(2) translate(0)", // zoom level 5
  "scale(2.2) translate(0)",
  "scale(2.4) translate(0)",
  "scale(2.6) translate(0)",
  "scale(2.8) translate(0)",
  "scale(3) translate(0)", // zoom level 10
  "scale(3.2) translate(0)",
  "scale(3.4) translate(0)",
  "scale(3.6) translate(0)",
  "scale(3.8) translate(0)",
  "scale(4) translate(0)", // zoom level 15
  "scale(4.2) translate(0)",
  "scale(4.4) translate(0)",
  "scale(4.6) translate(0)",
  "scale(4.8) translate(0)",
  "scale(5) translate(0)" // zoom level 20
];

export const MINIMIZE_COUNT = {
  docks: 10,
  lgv: 10,
  productionLine: 10
};
